
import {Component, Prop} from 'vue-property-decorator'
import { BaseClientComponent } from '@/components/base/BaseMixins'

@Component({components: {}})
export default class ClientName extends BaseClientComponent {
  @Prop({default: false}) hideNotes !: boolean
  @Prop({default: false}) link !: boolean
}
